import { render, staticRenderFns } from "./Provider.vue?vue&type=template&id=f1278a44&scoped=true"
import script from "./Provider.vue?vue&type=script&lang=js"
export * from "./Provider.vue?vue&type=script&lang=js"
import style0 from "./Provider.vue?vue&type=style&index=0&id=f1278a44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1278a44",
  null
  
)

export default component.exports